var TrilliumMvcActionAsyncLoader = (function ($) {

    var $ajaxContentContainer = $(".js-ajax-content-container");

    var renderAjaxContentElement = function (element) {
        const $element = $(element);
        $element.addClass('loaded');
        var $loadingElement = $element.find(".loading-element");
        if ($loadingElement.length < 1) {
            return;
        }
        $loadingElement.show();
        var $placeholder = $element.find(".placeholder");
        if ($placeholder.length < 1) {
            return;
        }
        $placeholder.hide();
        const url = $element.attr("data-url");
        if (!url) {
            return;
        }
        $placeholder.load(url,
            function () {
                $loadingElement.hide();
                $placeholder.show();

                var isRebindJsEventHandlers = $element.attr("data-isRebindJsEventHandlers");
                if (isRebindJsEventHandlers === 'True') {
                    rebindEventsOnAjax();
                }
            });
    };

    var renderAjaxContents = function () {
        if ($ajaxContentContainer.length < 1) {
            return;
        }
        $ajaxContentContainer.each(function () {
            renderAjaxContentElement(this);
        });
    };

    var retrieveAjaxContainers = function () {
        $ajaxContentContainer = $(".js-ajax-content-container:not(.loaded)");
    };

    return {
        init: function () {
            retrieveAjaxContainers();
            renderAjaxContents();
        }
    };

})(window.jQuery);

window.TrilliumMvcActionAsyncLoader = TrilliumMvcActionAsyncLoader;
